import React, { useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Sidebar from "./components/Sidebar";
import AboutPage from "./pages/AboutPage";
import TestCaseGenerator from "./pages/TestCaseGenerator";
import ToolsPage from "./pages/ToolsPage";
import QATutorials from "./pages/QATutorials";
import AutomationScriptWriter from "./pages/AutomationScriptWriter";
import BugSeverityAnalyzer from "./pages/BugSeverityAnalyzer";
import QAChatbot from "./pages/QAChatbot";
import TestSummary from "./pages/TestSummary";
import InterviewQuestions from "./pages/InterviewQuestions";


//import Logo from "./assets/qa_logo.png";

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Router>
      <div>

        {/* NAVBAR */}
        <nav className="navbar">

          {/* HAMBURGER BUTTON */}
          <button
            className={sidebarOpen ? "hamburger open" : "hamburger"}
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <svg width="30" height="30" viewBox="0 0 24 24">
              <path className="line top" d="M3 6h18" />
              <path className="line middle" d="M3 12h18" />
              <path className="line bottom" d="M3 18h18" />
            </svg>
          </button>

          {/* PLATFORM NAME + LINKS */}
          <div className="nav-left">
            <Link to="/" className="logo">QA AI Platform</Link>

            <div className="nav-links">
              <Link to="/">Home</Link>
              <Link to="/tools">AI Tools</Link>
              <Link to="/about">About</Link>
              <Link to="/chatbot">Chatbot</Link>
            </div>
          </div>

        </nav>

        {/* SIDEBAR */}
        <Sidebar
          isOpen={sidebarOpen}
          closeSidebar={() => setSidebarOpen(false)}
        />

        {/* MAIN CONTENT */}
        <div className={sidebarOpen ? "main-content shifted" : "main-content"}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/testcases" element={<TestCaseGenerator />} />
            <Route path="/bug-analyzer" element={<BugSeverityAnalyzer />} />
            <Route path="/script-writer" element={<AutomationScriptWriter />} />
            <Route path="/test-summary" element={<TestSummary />} />
            <Route path="/qa-chatbot" element={<QAChatbot />} />
            <Route path="/tutorials" element={<div>Tutorials Coming Soon</div>} />
            <Route path="/interview-questions" element={<InterviewQuestions />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/qa-tutorials" element={<QATutorials />} />
          </Routes>
        </div>

      </div>
    </Router>
  );
}

export default App;
